module.exports = __webpack_public_path__ + "img/016.363cda8c.jpg";